import {
  ActionSchema,
  DynamicBooleanSchema,
  DynamicNumberSchema,
  DynamicStringSchema,
  DynamicValueSchema,
} from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { FormDraftHandoff, type FormDraftResult } from './FormDraftHandoff';

interface ResolvedProps {
  readonly title?: string;
  readonly formName?: string;
  readonly answerCount?: number;
  /** Written reactively by the host at `/results/<id>`; never sent by the agent. */
  readonly result?: FormDraftResult;
  readonly pending?: boolean;
  readonly onStage?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  title: DynamicStringSchema,
  formName: DynamicStringSchema,
  answerCount: DynamicNumberSchema,
  result: DynamicValueSchema,
  pending: DynamicBooleanSchema,
  // Bound by the agent with the change-set as its context, and fired by the
  // component on mount rather than by a click. Declared here or the binder
  // drops it and the answers never reach the form.
  onStage: ActionSchema,
}) as any;

export const FormDraftHandoffImpl = createComponentImplementation(
  { name: 'FormDraftHandoff', schema },
  ({
    props,
  }: {
    props: ResolvedProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    buildChild: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    context: any;
  }) => (
    <FormDraftHandoff
      title={props.title ?? 'Answers from the document'}
      formName={props.formName}
      answerCount={props.answerCount}
      result={props.result as FormDraftResult | undefined}
      pending={props.pending === true}
      onStage={props.onStage}
    />
  )
);
